<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <g transform="translate(-1105.501 -613.396)">
      <g>
        <rect
          width="16"
          height="16"
          rx="2"
          transform="translate(1108.501 616.396)"
          fill="none"
        />
        <path
          d="M1122.5,632.4h-12a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2h12a2,2,0,0,1,2,2v12A2,2,0,0,1,1122.5,632.4Zm-12-15a1,1,0,0,0-1,1v12a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1v-12a1,1,0,0,0-1-1Z"
        />
      </g>
      <g>
        <rect
          width="6"
          height="6"
          rx="1"
          transform="translate(1113.501 621.396)"
          fill="none"
        />
        <path
          d="M1118.5,627.4h-4a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v4A1,1,0,0,1,1118.5,627.4Zm-4-5v4h4v-4Zm0-.5v.5h0Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1123.501 617.396)"
          fill="none"
        />
        <path
          d="M1127,618.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1105.501 617.396)"
          fill="none"
        />
        <path
          d="M1109,618.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1123.501 620.396)"
          fill="none"
        />
        <path
          d="M1127,621.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1105.501 620.396)"
          fill="none"
        />
        <path
          d="M1109,621.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1123.501 623.396)"
          fill="none"
        />
        <path
          d="M1127,624.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1105.501 623.396)"
          fill="none"
        />
        <path
          d="M1109,624.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1123.501 626.396)"
          fill="none"
        />
        <path
          d="M1127,627.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1105.501 626.396)"
          fill="none"
        />
        <path
          d="M1109,627.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1123.501 629.396)"
          fill="none"
        />
        <path
          d="M1127,630.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="4"
          height="1"
          transform="translate(1105.501 629.396)"
          fill="none"
        />
        <path
          d="M1109,630.4h-3a.5.5,0,0,1,0-1h3a.5.5,0,0,1,0,1Z"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1110.501 613.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1110.501 613.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1110.501 631.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1110.501 631.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1113.501 613.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1113.501 613.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1113.501 631.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1113.501 631.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1116.501 613.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1116.501 613.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1116.501 631.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1116.501 631.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1119.501 613.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1119.501 613.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1119.501 631.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1119.501 631.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1122.501 613.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1122.501 613.896)"
        />
      </g>
      <g>
        <rect
          width="1"
          height="4"
          transform="translate(1122.501 631.396)"
          fill="none"
        />
        <rect
          width="1"
          height="3"
          transform="translate(1122.501 631.896)"
        />
      </g>
    </g>
  </svg>
</template>
